module.exports = __webpack_public_path__ + "img/DM.3a68c10d.svg";